export const getBusinessProfileUrl = (id: number) => `/business/businesses/${id}`;

export const getBusinessesUrl = () => '/business/businesses';

export const getBusinessInteractionsLogsUrl = () => '/business/interactions';
